import { defineComponent } from 'vue'
import type { ExtractPropTypes } from 'vue'


export const querytableColumnIndexProps = () => ({})

export type QuerytableColumnIndexProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnIndexProps>>>

export default defineComponent({
  name: 'OQuerytableColumnIndex',
  inheritAttrs: false,
  props: querytableColumnIndexProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
